import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_URLS, PLATFORM_TYPE } from "../constants/constants";
import { parseJwt } from "../components/utilities/utils";

export const finalizeGenerateServiceApi = createApi({
  reducerPath: "finalizeGenerateServiceApi",
  keepUnusedDataFor:0.001,
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URLS.FINALIZE_GENERATE_BASE_URL,
    prepareHeaders: (headers) => {
      headers.set("authorization", `Bearer ${localStorage.access_token}`);
      headers.set("currentRole", localStorage.userrole);
      headers.set("atkn_bnd", localStorage?.atkn_bnd);
      headers.set("rtkn_bnd", localStorage?.rtkn_bnd);
      headers.set("channelidobo", "ETPBMS");
      headers.set("PLATFORM-TYPE", PLATFORM_TYPE);
      if(localStorage.userrole !== "eci")
      {
        headers.set("statecd", parseJwt(localStorage.access_token)?.authorizedStates?.[0]);
      }
      return headers;
    },
  }),

  endpoints: (builder) => ({
    getEpbCountCommonData: builder.query({
      query: () => ({
        headers: {
          // 'Authorization': 'Bearer ' + localStorage.access_token,
          "Content-Type": "application/json",
          // 'currentrole' : localStorage.userrole,
          // 'state': parseJwt(localStorage.access_token).authorizedStates?.[0],
        },
        url: `/v1/public/finalize/countCommonNodalData`,
        method: "GET",
      }),
    }),
    getEpbPinDownload: builder.query({
      query: () => ({
        headers: {
          // 'Authorization': 'Bearer ' + localStorage.access_token,
          "Content-Type": "application/json",
          //  'currentrole' : localStorage.userrole,
          //   'state': parseJwt(localStorage.access_token).authorizedStates?.[0],
        },
        url: `/v1/public/finalize/fetchNodalUnitOfficerData`,
        method: "GET",
      }),
    }),
    getElectionSchedule: builder.query({
      query: () => ({
        headers: {
          // 'Authorization': 'Bearer ' + localStorage.access_token,
          "Content-Type": "application/json",
          'constType': "AC",
          //  'currentrole' : localStorage.userrole,
          //   'state': parseJwt(localStorage.access_token).authorizedStates?.[0],
        },
        url: `/v1/public/finalize/getElectionDetails`,
        method: "GET",
      }),
    }),
    getEpbPinDownloadbyRo: builder.query({
      query: () => ({
        headers: {
          // 'Authorization': 'Bearer ' + localStorage.access_token,
          "Content-Type": "application/json",
          //  'currentrole' : localStorage.userrole,
          //   'state': parseJwt(localStorage.access_token).authorizedStates?.[0],
        },
        url: `/v1/public/finalize/fetchNodalRecordOfficerData`,
        method: "GET",
      }),
    }),

    getServiceVoterCount: builder.query({
      query: () => ({
        url: "/v1/public/finalize/getServiceVoterCount",
        method: "GET",
        headers: {
          "authorization": `Bearer ${localStorage.access_token}`,
          "Content-type": "application/json",
          "currentRole":localStorage.userrole,
          "constType":parseJwt(localStorage.access_token)?.constituencyType,
          "constNo": parseJwt(localStorage.access_token)?.authorizedPcs?.[0]
        },
      }),
    }),

    getserviceVotersData: builder.query({
      query: () => ({
        url: "/v1/public/finalize/serviceVotersData",
        method: "GET",
        headers: {
          "authorization": `Bearer ${localStorage.access_token}`,
          "Content-type": "application/json",
          "currentRole":localStorage.userrole,
          "constType":parseJwt(localStorage.access_token)?.constituencyType,
          "constNo": parseJwt(localStorage.access_token)?.authorizedPcs?.[0]
        },
      }),
    }),

    generateEpbPinAndId: builder.query({
      query: (data) => ({
        url: "/v1/public/finalize/generateEpbPINAndIDByRo",
        method: "GET",
        headers: {
          "authorization": `Bearer ${localStorage.access_token}`,
          "Content-type": "application/json",
          "currentRole":localStorage.userrole,
          "constType":parseJwt(localStorage.access_token)?.constituencyType,
          "constNo": parseJwt(localStorage.access_token)?.authorizedPcs?.[0]
        },
      }),
    }),
    saveEpbDetail: builder.mutation({
      query: (data) => ({
        url: "/v1/public/finalize/saveFinalizeEpbByRO",
        method: "Post",
        body: data,
        headers: {
          "Content-type": "application/json;",
          // Authorization: 'Bearer ' + localStorage.access_token,
          // currentRole: 'ero',
          "constType":parseJwt(localStorage.access_token)?.constituencyType ,
          "constNo":parseJwt(localStorage.access_token)?.authorizedPcs?.[0]
        },
      }),
    }),
    finalizeEPBByRO: builder.mutation({
      query: (data) => ({
        url: `/v1/public/finalize/finalizeEPBByRO`,
        method: "Post",
        body: data,
        headers: {
          "Content-type": "application/json;",
          // Authorization: 'Bearer ' + localStorage.access_token,
          // currentRole: 'ero',
          "constType":parseJwt(localStorage.access_token)?.constituencyType ,
          "constNo":parseJwt(localStorage.access_token)?.authorizedPcs?.[0]
        },
      }),
    }),
    getEpbDetail: builder.query({
      query: () => ({
        url: "/v1/public/finalize/getEpbGenerationDetails",
        method: "GET",
        headers: {
          "Content-type": "application/json;",
          // Authorization: 'Bearer ' + localStorage.access_token,
          // currentRole: 'ero',
          "constType":parseJwt(localStorage.access_token)?.constituencyType ,
          "constNo":parseJwt(localStorage.access_token)?.authorizedPcs?.[0]
        },
      }),
    }),

    saveBallotFile: builder.mutation({
      query: (data) => ({
        url: "/v1/public/finalize/ballotFileSaveRequest",
        method: "POST",
        body: data,
        headers: {
          "Content-type": "application/json;",
          // Authorization: 'Bearer ' + localStorage.access_token,
          // currentRole: 'ero',
          "constType":parseJwt(localStorage.access_token)?.constituencyType ,
          "constNo":parseJwt(localStorage.access_token)?.authorizedPcs?.[0]
        },
      }),
    }),

    saveEPbPaperFile: builder.mutation({
      query: (data) => ({
        url: "/v1/public/finalize/epbPaperFileSaveRequest",
        method: "POST",
        body: data,
        headers: {
          "Content-type": "application/json;",
          // Authorization: 'Bearer ' + localStorage.access_token,
          // currentRole: 'ero',
          "constType":parseJwt(localStorage.access_token)?.constituencyType ,
          "constNo":parseJwt(localStorage.access_token)?.authorizedPcs?.[0]
        },
      }),
    }),
    getEpbCount: builder.query({
      query: () => ({
        headers: {
          // 'Authorization': 'Bearer ' + localStorage.access_token,
          "Content-Type": "application/json",
          //  'currentrole' : localStorage.userrole,
          //   'state': parseJwt(localStorage.access_token).authorizedStates?.[0],
        },
        url: `/v1/public/finalize/countCommonRecordData`,
        method: "GET",
      }),
    }),
    getEpbdownload: builder.query({
      query: () => ({
        headers: {
          // 'Authorization': 'Bearer ' + localStorage.access_token,
          "Content-Type": "application/json",
          //    'currentrole' : localStorage.userrole,
          //     'state': parseJwt(localStorage.access_token).authorizedStates?.[0],
        },
        url: `/v1/public/finalize/fetchUnitOfficerDataRO`,
        method: "GET",
      }),
    }),
    GetEpbGenStatus: builder.mutation({
      query: (data) => ({
        url: `/v1/public/finalize/getEpbGenStatus`,
        method: "POST",
        body: data,
        headers: {
          "Content-type": "application/json;",
        },
      }),
    }),
    getEpbUnit: builder.mutation({
      query: (data) => ({
        url: "/v1/public/finalize/getElectionScheduleDetails",
        method: "Post",
        body: data,
        headers: {
          "Content-type": "application/json;",
          "constType":data?.constType
          // Authorization: 'Bearer ' + localStorage.access_token,
          // currentRole: localStorage.userrole,
          // state: parseJwt(localStorage.access_token).authorizedStates[0],
        },
      }),
    }),
    getEpbCountDetails: builder.mutation({
      query: (data) => ({
        url: "/v1/public/finalize/getElectionScheduleAndEbpCountDetails",
        method: "POST",
        body: data,
        headers: {
          "Content-type": "application/json;",
          "constType":data?.constType ,
        },
      }),
    }),

    getEpbDetailsByBatches: builder.mutation({
      query: (data) => ({
        url: "/v1/public/finalize/getEpbDetailsInBatch",
        method: "POST",
        body: data,
        headers: {
          "Content-type": "application/json;",
          "constType":data?.constType ,
        },
      }),
    }),
    FinalizationService: builder.query({
      query: () => ({
        url:
          "/v1/public/finalize/getServiceVotersByERO/" +
          parseJwt(localStorage.access_token).authorizedAcs[0],
        method: "GET",
        headers: {
          "Content-type": "application/json;",
          Authorization: "Bearer " + localStorage.access_token,
          currentRole: localStorage.userrole,
          state: parseJwt(localStorage.access_token).authorizedStates[0],
        },
      }),
    }),
    FinalizationServicePost: builder.mutation({
      query: (data) => ({
        url: "/v1/public/finalize/finalizeServiceVotersByERO",
        method: "Post",
        body: data,
        headers: {
          "Content-type": "application/json;",
          Authorization: "Bearer " + localStorage.access_token,
          currentRole: localStorage.userrole,
          state: parseJwt(localStorage.access_token).authorizedStates[0],
        },
      }),
    }),
    finalizeServicevoterUploadFile: builder.mutation({
      query: (data) => ({
        url: "/v1/public/finalize/finalizeServiceVotersByERO",
        method: "POST",
        body: data,
        // headers: {
        //     'Authorization': 'Bearer ' + localStorage.access_token,
        //     'currentrole': "ero",
        //     'Content-Type': 'application/json',
        // },
      }),
    }),

    getServiceVoterData: builder.query({
      query: () => ({
        url: "/v1/public/finalize/getServiceVoterData",
        method: "GET",
        // headers: {
        //     'Authorization': 'Bearer ' + localStorage.access_token,
        //     'currentrole': "ero",
        //     'Content-Type': 'application/json',
        // },
      }),
    }),
    GetFilePath: builder.query({
      query: () => ({
        url: "/v1/public/finalize/templatePaths",
        method: "GET",
        headers: {
          "Content-type": "application/json;",
        },
      }),
    }),
    otpSendForEtpbms: builder.mutation({
      query: (data) => ({
        url: "v1/public/finalize/send",
        method: "POST",
        headers: {
          "constType":parseJwt(localStorage.access_token)?.constituencyType,
          "constNo": parseJwt(localStorage.access_token)?.authorizedPcs?.[0]
        },
        body:data
      }),
    }),
    otpVerifyForEtpbms: builder.mutation({
      query: (data) => ({
        url: "v1/public/finalize/verify",
        method: "POST",
        headers: {
          "constType":parseJwt(localStorage.access_token)?.constituencyType,
          "constNo": parseJwt(localStorage.access_token)?.authorizedPcs?.[0]
        },
        body:data
      }),
    }),
    getEpbBallotUpdated: builder.mutation({
      query: (data) => ({
        url: '/v1/public/finalize/getEpbBallotUpdated',
        method: 'Post',
        body: {
          id: data?.id,
          electionType: data?.electionType,
        },
        headers: {
          'Content-Type': 'application/json',
          'constType': data?.constType,
        },
      }),
    }),
    getEpbPinUpdated: builder.mutation({
      query: (data) => ({
        url: '/v1/public/finalize/getEpbPinUpdated',
        method: 'Post',
        body: {
          officerId: data?.officerId,
          stateCd: data?.stateCd,
          statePhaseNo : data?.statePhaseNo,
          "constType": data?.constType,
          electionType: data?.electionType,
        },
        headers: {
          'Content-Type': 'application/json',
          'constType': data?.constType,
          constNo: data?.constNo,
        },
      }),
    }),
  }),
});
export const {
  useGetEpbCountCommonDataQuery,
  useGetEpbPinDownloadQuery,
  useGetEpbPinDownloadbyRoQuery,
  useSaveBallotFileMutation,
  useGetServiceVoterCountQuery,
  useGetserviceVotersDataQuery,
  useGenerateEpbPinAndIdQuery,
  useSaveEpbDetailMutation,
  useFinalizeEPBByROMutation,
  useGetEpbDetailQuery,
  useSaveEPbPaperFileMutation,
  useGetEpbUnitMutation,
  useGetEpbCountQuery,
  useGetEpbdownloadQuery,
  useGetEpbGenStatusMutation,
  useGetEpbCountDetailsMutation,
  useGetEpbDetailsByBatchesMutation,
  useFinalizationServiceQuery,
  useFinalizationServicePostMutation,
  useFinalizeServicevoterUploadFileMutation,
  useGetServiceVoterDataQuery,
  useGetFilePathQuery,
  useGetElectionScheduleQuery,
  useOtpSendForEtpbmsMutation,
  useOtpVerifyForEtpbmsMutation,
  useGetEpbBallotUpdatedMutation,
  useGetEpbPinUpdatedMutation

} = finalizeGenerateServiceApi;
